// store/slices/waterBillsSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchBillsByHouseThunk = createAsyncThunk(
  "waterBills/fetchByHouse",
  async (home_id, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/api/water-bills/house/${home_id}`);
      if (!data?.success) return rejectWithValue(data?.message || "Failed");
      return data.data || [];
    } catch (e) {
      return rejectWithValue(e?.response?.data?.message || e.message);
    }
  }
);

export const deleteBillThunk = createAsyncThunk(
  "waterBills/delete",
  async ({ wb_id }, { rejectWithValue }) => {
    try {
      const { data } = await api.delete(`/api/water-bills/${wb_id}`);
      if (!data?.success) return rejectWithValue(data?.message || "Failed");
      return wb_id;
    } catch (e) {
      return rejectWithValue(e?.response?.data?.message || e.message);
    }
  }
);

const waterBillsSlice = createSlice({
  name: "waterBills",
  initialState: {
    list: [],
    loading: false,
    error: null,
    deletingId: null,
  },
  reducers: {
    clearWaterBillsError: (s) => {
      s.error = null;
    },
    clearWaterBillsList: (s) => {
      s.list = [];
    },
  },
  extraReducers: (b) => {
    b.addCase(fetchBillsByHouseThunk.pending, (s) => {
      s.loading = true;
      s.error = null;
    });
    b.addCase(fetchBillsByHouseThunk.fulfilled, (s, a) => {
      s.loading = false;
      s.list = a.payload || [];
    });
    b.addCase(fetchBillsByHouseThunk.rejected, (s, a) => {
      s.loading = false;
      s.error = a.payload || "Failed";
    });

    b.addCase(deleteBillThunk.pending, (s, a) => {
      s.deletingId = a.meta.arg?.wb_id || null;
      s.error = null;
    });
    b.addCase(deleteBillThunk.fulfilled, (s, a) => {
      s.deletingId = null;
      s.list = (s.list || []).filter((x) => String(x.wb_id) !== String(a.payload));
    });
    b.addCase(deleteBillThunk.rejected, (s, a) => {
      s.deletingId = null;
      s.error = a.payload || "Failed";
    });
  },
});

export const { clearWaterBillsError, clearWaterBillsList } = waterBillsSlice.actions;
export default waterBillsSlice.reducer;
